<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link
						:to="'/admin/listado/contactos-categorias'"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<span>{{ $t('categorias') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
				<ButtonBlack class="ml-2">
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="contacts"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import { fetchContactsList } from '@/apollo/contacts'

export default {
	apollo: {
		contacts: fetchContactsList()
	},
	data() {
		return {
			section: 'contactos',
			itemsTable: 'contacts',
			itemsTitles: ['Id', 'Nombre', 'position', 'Email', 'Telefono']
		}
	},
	components: { ListTable }
}
</script>
